import React from "react"
import theme from "./../../../Theme/Theme"
import { Div, Text } from "atomize";
import PhaseNum from './../PhaseNum';
import Skeleton from 'react-loading-skeleton';
import styled from "styled-components";

const Wrapper = styled(Div)`
  display: flex;
  justify-content: center;
  position: relative;
  margin: 4rem 0;
  
  &:before {
    content: "";
    width: 100%;
    position: absolute;
    height: 1px;
    background-color: ${ props => props.hideline === "true" ? 'transparent' : theme.colors.gray };
    top: 50%;
    z-index: -1;
  }
  .extension {
    color: ${theme.colors.primary}
  }
`;

const Item = styled(Div)`
  box-sizing: 
  border-box;	
  min-height: 51px;
  border: 1px solid ${theme.colors.gray};	
  border-radius: 25.5px;	
  background-color: ${theme.colors.white};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 10px 1.25rem;
  margin: 0 1rem;
`;

const Title = styled(Text)`
  width: 100%;
  color: ${theme.colors.dark};	
  font-size: ${ props => props.size === 'small' ? '14px' : '16px'};	
  font-weight: 600;	
  line-height: 25px;	
  text-align: center;
  
  display: flex;
  
  svg {
    margin-left: .5rem;
    transform: scale(.75);
  }
`;

const formatMateralTitle = (material) => {
  let ext = (material.match(/\.([^.]*?)(?=\?|#|$)/) || [])[1];
  return (
    <span>{material.replace("." + ext, "")}<span className={"extension"}>{"." + ext}</span></span>
  )
};

function Heading(props) {
  let formattedTitle = null;
  if (props.formatHeading) {
    formattedTitle = formatMateralTitle(props.title)
  }
  return (
    <Wrapper
      hideline={props.hideline ? 'true' : 'false'}
    >
      <Item>
        <Title
          tag="h3"
          size={props.size}
          id={ props.id ? props.id : null }
        >
          {
            props.loading &&
              <Skeleton
                width={150}
              />
          }

          { props.formatHeading ? formattedTitle : props.title}
          { props.count && props.phase &&
            <PhaseNum
              count={props.count}
            />
          }
        </Title>
      </Item>
    </Wrapper>
  )
}



export default Heading
